<micro-select-combo #sel
              placeholder="Object Group"
              routerBase="/objectGroups"
              [(id)]="objectGroupId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
